import { type FC, useContext } from "react";
import { isRecord } from "../../../../types/internal/utility";
import { type ListColumnMap, ListComponent } from "../../Forms/DragDrop/ComponentBases/ListComponent";
import { DragDropComponentErrorContext } from "../../Forms/DragDrop/DragDropComponent";
import { DragDropDataContext } from "../../Forms/DragDrop/DragDropRenderer";
import { type ComponentOptions } from "../../Forms/DragDrop/DragDropTypes";
import { hasColumnsValue } from "../../Forms/DragDrop/ReorderableTableSettings";

const ACCOUNT_COLUMNS: ListColumnMap = {
    "start-balance": {
        valueStyle: {
            width: "6em",
        },
    },
    "end-balance": {
        valueStyle: {
            width: "6em",
        },
    },
    "changed-balance": {
        valueStyle: {
            width: "6em",
        },
    },
    "current-balance": {
        valueStyle: {
            width: "6em",
        },
    },
};

export const ReceiptAccountTableComponent: FC<ComponentOptions> = ({
    style,
    value,
}) => {
    const { account } = useContext(DragDropDataContext);

    const error = useContext(DragDropComponentErrorContext);

    if(!isRecord(account)) {
        return error;
    }

    if(!hasColumnsValue(value)) {
        return error;
    }

    return (
        <ListComponent
            style={style}
            value={value.columns}
            columns={ACCOUNT_COLUMNS}
            data={account}
        />
    );
};
